export default {
    START: "Start",
    UNSUCCESS: "Unsuccess",
    SUCCESS: "Success",
};
export var KEY_LOCAL_STORAGE = "maat_token_process";
export var KEY_LOCAL_STORAGE_GEO = "maat_liveness";
// Liveness-check origin sent to /lifetest/usage, provided by the embedder via
// the `usagetype` query param.
export var USAGE_TYPES = {
    F2F_2FA: "F2F_2FA", // Android SDK (2FA)
    F2F_PROOF_OF_LIFE: "F2F_PROOF_OF_LIFE", // Android SDK (F2F client / Login with Maat)
    WEB_PROOF_OF_LIFE: "WEB_PROOF_OF_LIFE", // Webview / IDPal (end user)
    WEB_LOGIN: "WEB_LOGIN", // Webview / IDPal (login/access)
};
// This webview serves the end user.
export var DEFAULT_USAGE_TYPE = USAGE_TYPES.WEB_PROOF_OF_LIFE;
var VALID_USAGE_TYPES = Object.keys(USAGE_TYPES).map(function (key) { return USAGE_TYPES[key]; });
export var normalizeUsageType = function (value) {
    return value && VALID_USAGE_TYPES.indexOf(value) !== -1
        ? value
        : DEFAULT_USAGE_TYPE;
};
